import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Paneset, Loading } from '@folio/stripes/components';
import SaveNewReportManager from '../../components/reports/management/save/SaveNewReportManager';
import QueryBuilderManger from '../../components/reports/builders/advanced/QueryBuilderManger';
import useURLParams from '../../hooks/useURLParams';
import useReportContext from '../../hooks/useReportContext';
import useReportsConfigs from '../../hooks/useReportsConfigs';
import ResultsPreview from '../../components/reports/results/preview/ResultsPreview';
import useCubeQuery from '../../hooks/useQuery';

function QueryBuilderRoute(props) {
  const [reportType, setReportType] = useURLParams('rt', 'statistical');
  const [query, setQuery] = useURLParams('q', '');

  const {
    reportId, reportName, reportDesc,
    isRunMode, isEditMode,
    defaultDisplayMethod: savedDefaultDisplay,
    displayMethods: savedDisplayMethods,
    returnSearch,
    isContextLoading,
  } = useReportContext(props.location);
  const [displayMethod, setDisplayMethod] = useURLParams('dm', savedDefaultDisplay);

  const [selectedTables, setSelectedTables] = useState([]);
  const [showQueryBuilderPane, setShowQueryBuilderPane] = useState(true);
  const [showSavePane, setShowSavePane] = useState(false);
  const [currentQuery, setCurrentQuery] = useState('');
  const [queryOptions, setQueryOptions] = useState({});
  const [resultSet, error, isLoading] = useCubeQuery(
    currentQuery,
    queryOptions,
  );

  const [initialValues, setInitialValues] = useState({
    tables: [],
    columns: {},
    dimFilters: [],
    metFilters: [],
    metrics: [],
    orders: [],
    timeDimentions: {
      timeColumn: '',
      timeUnit: 'day',
      dateRange: '',
    },
    segments: '',
  });

  const handleClose = () => {
    props.history.push('/reports/report-builder');
  };

  return (
    <>
      <Paneset>
        <QueryBuilderManger
          {...props}
          reportType={reportType}
          setReportType={setReportType}
          showQueryBuilderPane={showQueryBuilderPane}
          setShowQueryBuilderPane={setShowQueryBuilderPane}
          handleClose={handleClose}
          initialValues={initialValues}
          setQuery={(newQuery, options = {}) => {
            setQuery(newQuery);
            setCurrentQuery(newQuery);
            setQueryOptions(options);
          }}
          selectedTables={selectedTables}
          setSelectedTables={setSelectedTables}
        />
        <ResultsPreview
          {...props}
          showQueryBuilderPane={showQueryBuilderPane}
          setShowQueryBuilderPane={setShowQueryBuilderPane}
          showSavePane={showSavePane}
          setShowSavePane={setShowSavePane}
          handleClose={handleClose}
          query={currentQuery}
          resultSet={resultSet}
          error={error}
          isLoading={isLoading}
          reportType={reportType}
          displayMethod={displayMethod}
          setDisplayMethod={setDisplayMethod}
          savedDisplayMethods={savedDisplayMethods}
          reportId={reportId}
          reportName={reportName}
          reportDesc={reportDesc}
          isRunMode={isRunMode || false}
          isEditMode={isEditMode || false}
        />
        <SaveNewReportManager
          {...props}
          showQueryBuilderPane={showQueryBuilderPane}
          setShowQueryBuilderPane={setShowQueryBuilderPane}
          showSavePane={showSavePane}
          setShowSavePane={setShowSavePane}
          handleClose={handleClose}
          query={currentQuery}
          reportType={reportType}
          builderType="advanced"
          builderState={query}
        />
      </Paneset>
    </>
  );
}

QueryBuilderRoute.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    goBack: PropTypes.func.isRequired,
  }).isRequired,
  location: PropTypes.object,
};

export default QueryBuilderRoute;
